module.exports = __webpack_public_path__ + "fonts/f741a4c637828c76eb02951046ea7cf5.svg";